// extracted by mini-css-extract-plugin
export default {"colors":"\"../styles/colors.css\"","primaryColor":"#3A237B","primaryLight":"#CCD1E3","secondaryColor":"#E33F75","wrapper":"Loader_wrapper__Uq7Q6"};